export enum CoreRows {
    Construction = 'Construction',
    FixFlip = 'Total Fix-Flip',
    Land = 'Land',
    SubTotal = 'Sub-Total',
    ExcessBridge = 'Excess Bridge*',
    Core = 'Core',
}
